import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  textFieldStyle: {
    '& .MuiInputBase-input': {
      padding: '12px 8px',
      backgroundColor: Colors.White,
    },
  },
  wrapFormYearInput: {
    width: '22%',
    marginRight: 16,
  },
  wrapFormDescriptionInput: {
    width: '80%',
  },
  wrapInput: {
    display: 'flex',
    marginTop: -10,
  },
}));

export default useStyles;
